import request from './request'

export default {
  changePassword(data) {
    return request.post('/secrity/changePassword', data)
  },
}
